import styled from 'styled-components';

import { variableFontRegular } from 'styles/theme/text';

interface IFitFeedbackFormUserHeight {
  measurement: string;
  name: string;
  onChange: (e) => void;
  onBlur: (e) => void;
  value: string;
}

export const FitFeedbackFormUserHeight = ({
  measurement,
  name,
  onBlur,
  onChange,
  value,
}: IFitFeedbackFormUserHeight) => {
  return (
    <FitFeedbackFormUserHeight.HeightInputWrapper>
      <FitFeedbackFormUserHeight.HeightInput
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        name={name}
        type="text"
        inputMode="numeric"
        data-qa={`fit_feedback_form_height_${name}`}
      />
      <FitFeedbackFormUserHeight.SelectedHeightMeasurement>
        {measurement}
      </FitFeedbackFormUserHeight.SelectedHeightMeasurement>
    </FitFeedbackFormUserHeight.HeightInputWrapper>
  );
};

FitFeedbackFormUserHeight.HeightInputWrapper = styled.div`
  position: relative;
  width: 60px;
  ${variableFontRegular({ size: '9.5px', height: '12px' })};
  margin-right: 8px;
`;

FitFeedbackFormUserHeight.HeightInput = styled.input`
  border: ${({ theme }) => theme.borders.black};
  padding: 4px 26px 4px 8px;
  border-radius: 0;

  &:focus {
    outline: none;
  }
`;

FitFeedbackFormUserHeight.SelectedHeightMeasurement = styled.span`
  position: absolute;
  right: 8px;
  top: 4px;
  text-transform: uppercase;
`;
